module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-48.2b66cc8e.png";